import React, { Component } from "react";
import crypto from "crypto";
import axios from '@app/lib/axios';
import { toast, ToastContainer, Slide } from "react-toastify";
import lscache from "lscache";

import * as Constant from "../../Constant.js";

import "./login.css";

export default class LoginHQ extends Component {
    constructor(props) {
        super(props);

        const urlParams = new URLSearchParams(window.location.search);
        const type = urlParams.get('type');
        this.state = {
            id: this.props.id ? this.props.id : "",
            pass: this.props.pass ? this.props.pass : "",
            type: type ? type : "admin",
        };
    }

    onFormSubmit = (e) => {
        e.preventDefault();
        if (!e.target.id.value) {
            alert("사용자 아이디를 입력해주세요.");
            return;
        }

        if (!e.target.pass.value) {
            alert("패스워드를 입력해주세요.");
            return;
        }

        axios({
            method: "post",
            url: `${Constant.API_DOMAIN}/api/user/${this.state.type}/login`,
            data: { id: e.target.id.value, pass: crypto.createHash("md5").update(e.target.pass.value).digest("hex") },
        })
            .then((result) => {
                lscache.flush();
                if (result.data.code === 200) {
                    localStorage.setItem("is_login", true);
                    localStorage.setItem("is_login_from_hq", "yes");
                    localStorage.setItem("login_user_type", result.data.user.type);
                    localStorage.setItem("login_user_name", result.data.user.name);
                    localStorage.setItem("login_user_id", result.data.user.user_id);
                    localStorage.setItem("login_user_index", result.data.user.id);
                    localStorage.setItem("login_user_role", result.data.user.role);
                    localStorage.setItem("login_user_roleArr", result.data.user.roleArr);
                    localStorage.setItem("auth_token", result.data.user.authToken);

                    if (result.data.user.role === "branch") {
                        localStorage.setItem("login_branch_id", result.data.user.branch.id);
                        localStorage.setItem("login_branch_name", result.data.user.branch.name);
                    }

                    // toast.success("로그인 되었습니다.");
                    // this.props.changeLoginInfo(true);
                    const urlParams = new URLSearchParams(window.location.search);
                    const redirect = urlParams.get('redirect');
                    document.location = redirect ? redirect : `${process.env.REACT_APP_BASE_URL}${result.data.user.menuRoot}`;
                } else {
                    alert(result.data.msg);
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    render() {
        return (
            <div className="splash-container">
                <div className="card ">
                    <div className="card-header text-center" style={{ display: "block" }}>
                        <h2 className="navbar-brand mb-0" style={{ textTransform: "normal" }}>
                            TAS
                        </h2>
                        <h4 className="mt-0">(Tomo Assistant System)</h4>
                        <span className="splash-description">본사 로그인 페이지</span>
                    </div>
                    <div className="card-body">
                        <form onSubmit={this.onFormSubmit}>
                            <div className="text-center">
                                <label htmlFor="loginAdmin" className="custom-control custom-radio custom-control-inline">
                                    <input
                                        id="loginAdmin"
                                        type="radio"
                                        className="custom-control-input"
                                        name="type"
                                        checked={this.state.type === "admin"}
                                        value="admin"
                                        onChange={(e) => {
                                            this.setState({
                                                type: e.target.value,
                                            });
                                        }}
                                    />
                                    <span className="custom-control-label">관리자</span>
                                </label>
                                <label htmlFor="loginBranch" className="custom-control custom-radio custom-control-inline">
                                    <input
                                        id="loginBranch"
                                        type="radio"
                                        className="custom-control-input"
                                        name="type"
                                        checked={this.state.type === "branch"}
                                        value="branch"
                                        onChange={(e) => {
                                            this.setState({
                                                type: e.target.value,
                                            });
                                        }}
                                    />
                                    <span className="custom-control-label">지사</span>
                                </label>
                            </div>
                            <div className="form-group">
                                <input
                                    className="form-control form-control-lg"
                                    name="id"
                                    ref={(ref) => {
                                        this.id = ref;
                                    }}
                                    placeholder="User ID"
                                    autoComplete="off"
                                />
                            </div>
                            <div className="form-group">
                                <input className="form-control form-control-lg" name="pass" type="password" placeholder="Password" />
                            </div>
                            <button type="submit" className="btn btn-primary btn-lg btn-block">
                                Login
                            </button>
                        </form>
                    </div>
                </div>
                <ToastContainer autoClose={2000} hideProgressBar={true} transition={Slide} />
            </div>
        );
    }
}
